import * as Sentry from "@sentry/react";
import { eventSortFn, generateRegistrationCloseTime, getUTCTime } from "../helpers/event";
import { graphql } from "./wp.api.service";
import { loader } from "graphql.macro";

import { transformSeries } from "./wp.course.query";

const gqlQuery = loader("../queries/coursesQuery.gql");

export const transformCourse = ({ node }) => ({
	...node,
	...node.coursesInfo,
	...node.courseTiming,
	// eslint-disable-next-line camelcase, no-shadow
	audience_type: node.audienceTypes?.edges ? node.audienceTypes.edges.map(({ node }) => node.name) : null,
	diagnoses: node.diagnoses?.edges ? node.diagnoses.edges.map(({ node: diagnosis }) => diagnosis.name) : null,
	end: getUTCTime(`${node.courseTiming.coursedate}T${node.courseTiming.endtime}`),
	facilitator: node.facilitator?.edges ? node.facilitator.edges.map(({ node: fac }) => fac.name).join(", ") : null,
	facilitatorId: node.facilitator?.edges ? node.facilitator.edges.map(({ node: fac }) => fac.id) : null,
	id: node.databaseId,
	languages: node.languages?.edges ? node.languages.edges.map(({ node: language }) => language.name) : null,
	location: node.location && node.location.node && node.location.node.name ? node.location.node.name.trim() : null,
	locationAbbr: node.location && node.location.node && node.location.node.abbreviation ? node.location.node.abbreviation.trim() : null,
	programs: node.programs?.edges ? node.programs.edges.map(({ node: program }) => program.name) : null,
	recurringClasses: node.recurringClasses?.edges?.length ? node.recurringClasses.edges[0] : null,
	registrationClose: node.courseTiming.registrationclose
		? getUTCTime(node.courseTiming.registrationclose)
		: generateRegistrationCloseTime(node),
	registrationOpen: node.courseTiming.registrationopen ? getUTCTime(node.courseTiming.registrationopen) : null,
	series: node.series?.edges[0] ? transformSeries(node.series.edges[0]) : null,
	start: getUTCTime(`${node.courseTiming.coursedate}T${node.courseTiming.starttime}`),
	type: node.courseTypes.edges.map(({ node: type }) => type).map(({ slug }) => slug)
});

/**
 * Events Query
 *
 * @param {*} useQuery The useQuery instance.
 * @param {*} where    The where parameters to search.
 * @param {*} options  Any custom useQuery options.
 * @returns Promise
 */
// eslint-disable-next-line max-params
export const getCourses = (useQuery, where, options, noAuth = true) => {
	const variables = {
		where
	};

	// eslint-disable-next-line no-unused-vars
	const query = gqlQuery.loc.source.body;

	let cacheId = null;

	if (where?.query?.start_date?.min && where?.query?.start_date?.max) {
		cacheId = `getEvents_${where.query.start_date.min}_${where.query.start_date.max}`;
	}

	return useQuery(
		["courses", where],
		() => graphql({
			cacheId,
			operationName: "CourseQuery",
			query,
			variables
		}, noAuth, { cacheId }).
			then((res) => {
				const { pager } = res.data.data.courseFacet;

				let courses = [];
				if (pager.total_rows > 0) {
					try {
						courses = res.data.data.courseFacet.courses.edges.
							map(transformCourse).
							sort(eventSortFn);
					} catch (error) {
						Sentry.captureException(error);
					}
				}

				return {
					...res.data.data.courseFacet,
					courses
				};
			}),
		{
			staleTime: 10 * 60 * 1000,
			useErrorBoundary: true,
			...options
		}
	);
};
